<template>
	<div class="share-group">
		<a class="share-link" :href="facebookShareURL" target="_blank" @click="trackShare('Facebook')">
			<img class="social-icon facebook-icon" src="@/assets/images/facebook-icon.svg" />
		</a>
		<a class="share-link" :href="twitterShareURL" target="_blank" @click="trackShare('Twitter')">
			<img class="social-icon twitter-icon" src="@/assets/images/twitter-icon.svg" />
		</a>
	</div>
</template>

<script>
import { mapState } from 'vuex';

export default {
	name: 'SocialShare',
	computed: {
		...mapState({
			social: (state) => state.global.api.data.social,
		}),
		encodedUrl() {
			return encodeURIComponent(window.location.origin);
		},
		facebookShareURL() {
			return `https://www.facebook.com/sharer/sharer.php?u=${this.encodedUrl}&quote=${encodeURIComponent(this.shareText)}`;
		},
		twitterShareURL() {
			return `https://twitter.com/share?url=${this.encodedUrl}&text=${encodeURIComponent(this.shareText)}`;
		},
		shareText() {
			return this.social.twitter.share_text;
		},
	},
	methods: {
		trackShare(site) {
			this.$store.dispatch("global/analytics/trackEvent", { ec: "Social", el: site, ea: "Share" });
		},
	},
};
</script>

<style lang="scss" scoped>
	.share-group { display: flex; }

	.share-link {
		display: inline-block;
		width: 50px;
		height: 50px;

		& + & { margin-left: 1rem; }
	}

	.social-icon { border-radius: 50%; }

	// .facebook-icon,
	// .twitter-icon {
	// 	rect { fill: $alt-color-light; }
	// 	path { fill: $little-bummer-1; }
	// }
</style>
